/**
 * Vies API - Auto-generated typed wrapper.
 * DO NOT EDIT - Regenerate with: bun run generate
 * @generated
 */

import { checkVies } from "../generated/vies/vies";

import { wrapMethod } from "./utils";

export const vies = {
  /** @see checkVies */
  checkVies: wrapMethod(checkVies),
} as const;

export type ViesApi = typeof vies;
